import '../../components/styles/PharmacovigilanceCommittee.css';
import '../../components/styles/CommitteeTable.css';

const PharmacovigilanceCommittee = () => {
  const members = [
    { sl: 1, name: 'Dr. Prasath. C', designation: 'Medical Superintendent', position: 'Chairperson' },
    { sl: 2, name: 'Dr. Nitya. S', designation: 'Professor & HOD of Pharmacology', position: 'Member Secretary' },
    { sl: 3, name: 'Dr. Rubysultana', designation: 'Associate Professor of OBG', position: 'Member' },
    { sl: 4, name: 'Dr. Harish Kumar. M', designation: 'Assistant Professor Surgery', position: 'Member' },
    { sl: 5, name: 'Dr. Praveenkumar. K', designation: 'Assistant Professor of Paediatrics', position: 'Member' },
    { sl: 6, name: 'Dr. Vimal kumar A.G', designation: 'Senior Resident of General Medicine', position: 'Member' },
    { sl: 7, name: 'Dr. Gunalan. P', designation: 'Assistant Professor of Dermatology', position: 'Member' },
    { sl: 8, name: 'Dr. M. Aljin Jino', designation: 'Assistant Professor of Psychiatry', position: 'Member' },
    { sl: 9, name: 'Mrs. Glory', designation: 'Nursing Superintendent', position: 'Member' },
    { sl: 10, name: 'Mr. Arul Selvan', designation: 'Chief Pharmacist', position: 'Member' },
  ];

  const pdfPath = '/assets/document/committee/pharmacovigilance-committee/Pharmacovigilance committee.pdf';

  return (
    <div className="pharma-container">
      <header className="pharma-header">
        <h1>Pharmacovigilance Committee (Reconstituted)</h1>
      </header>

      <section className="pharma-description">
        <p>
          The Pharmacovigilance Committee is responsible for ensuring the safe and effective use
          of medicines within the institution. This committee monitors adverse drug reactions,
          promotes awareness about drug safety among healthcare professionals and students, and
          ensures compliance with national pharmacovigilance guidelines. Through active surveillance
          and continuous training, the committee plays a crucial role in protecting patient
          well-being and enhancing therapeutic outcomes.
        </p>
      </section>

      <section className="pharma-table-section">
        <div className="ct-table-wrapper">
          <table className="pharma-table ct-table">
            <thead>
              <tr>
                <th>Sl. No.</th>
                <th>Name & Designation</th>
                <th>Position</th>
              </tr>
            </thead>
            <tbody>
              {members.map((m) => (
                <tr key={m.sl}>
                  <td className="ct-sl" data-label="Sl.">{m.sl}</td>
                  <td data-label="Name & Designation">{m.name}, {m.designation}</td>
                  <td data-label="Position">{m.position}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      <div className="ct-doc-btn-wrap">
        <a href={`/view-document.html?file=${encodeURIComponent(pdfPath)}`} target="_blank" rel="noopener noreferrer" className="ct-doc-btn">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
            <line x1="12" y1="18" x2="12" y2="12"/>
            <line x1="9" y1="15" x2="15" y2="15"/>
          </svg>
          View Official Document
        </a>
      </div>
    </div>
  );
};

export default PharmacovigilanceCommittee;
